import { gql } from 'graphql-request'

export const QueryBlockHubSpotCalendar = gql`
  fragment FragmentBlockHubSpotCalendar on HubSpotCalendarModelRecord {
          __typename
          id
          title
          headingType
          description {
            value
          }
          calendarUrl
          jsScript
          bulletPoints {
            ...FragmentFormattedTextBlock
          }
        }
`
export const HubSpotCalendar = {
  __typename: 'HubSpotCalendar',
  fragmentName: 'FragmentBlockHubSpotCalendar',
  fragmentQuery: QueryBlockHubSpotCalendar,
  fragments: []
}
